var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 22,
  r: 15,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.976 31.152C5.94133 30.1493 5.136 28.8693 4.56 27.312C3.99467 25.7547 3.712 24.0853 3.712 22.304C3.712 20.48 4.01067 18.768 4.608 17.168C5.20533 15.5573 6.07467 14.24 7.216 13.216H9.472V13.424C8.29867 14.544 7.40267 15.888 6.784 17.456C6.176 19.024 5.872 20.64 5.872 22.304C5.872 23.9253 6.16 25.4933 6.736 27.008C7.32267 28.512 8.15467 29.8187 9.232 30.928V31.152H6.976Z",
  fill: "#ADB4C3"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20.528 31.152V30.928C21.6053 29.8187 22.432 28.512 23.008 27.008C23.5947 25.4933 23.888 23.9253 23.888 22.304C23.888 20.64 23.5787 19.024 22.96 17.456C22.352 15.888 21.4613 14.544 20.288 13.424V13.216H22.544C23.6853 14.24 24.5547 15.5573 25.152 17.168C25.7493 18.768 26.048 20.48 26.048 22.304C26.048 24.0853 25.76 25.7547 25.184 27.312C24.6187 28.8693 23.8187 30.1493 22.784 31.152H20.528Z",
  fill: "#ADB4C3"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_520_486)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.9977 13L14.877 13.4102V25.3121L14.9977 25.4326L20.5223 22.1669L14.9977 13Z",
  fill: "#343434"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.9974 13L9.47266 22.1669L14.9974 25.4326V19.6557V13Z",
  fill: "#8C8C8C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.9977 26.4788L14.9297 26.5618V30.8014L14.9977 31.0001L20.5257 23.2148L14.9977 26.4788Z",
  fill: "#3C3C3B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.9974 31.0001V26.4788L9.47266 23.2148L14.9974 31.0001Z",
  fill: "#8C8C8C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.998 25.4331L20.5227 22.1674L14.998 19.6562V25.4331Z",
  fill: "#141414"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.47266 22.1674L14.9974 25.4331V19.6562L9.47266 22.1674Z",
  fill: "#393939"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M29.873 11.578C30.449 11.098 30.908 10.699 31.25 10.381C31.592 10.057 31.877 9.721 32.105 9.373C32.333 9.025 32.447 8.683 32.447 8.347C32.447 8.041 32.375 7.801 32.231 7.627C32.087 7.453 31.865 7.366 31.565 7.366C31.265 7.366 31.034 7.468 30.872 7.672C30.71 7.87 30.626 8.143 30.62 8.491H29.396C29.42 7.771 29.633 7.225 30.035 6.853C30.443 6.481 30.959 6.295 31.583 6.295C32.267 6.295 32.792 6.478 33.158 6.844C33.524 7.204 33.707 7.681 33.707 8.275C33.707 8.743 33.581 9.19 33.329 9.616C33.077 10.042 32.789 10.414 32.465 10.732C32.141 11.044 31.718 11.422 31.196 11.866H33.851V12.91H29.405V11.974L29.873 11.578Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_520_486"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  fill: "white",
  transform: "translate(6 13)"
})));

function SvgIconEth2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEth2);
export default __webpack_public_path__ + "static/media/Icon_ETH2.2ae4a02e7ec4d339cfdb4a92eca27316.svg";
export { ForwardRef as ReactComponent };